<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M0 8a8 8 0 1 0 7.992-8A8 8 0 0 0 0 8z" style="fill:#5b80eb" fill="currentColor"/><path d="M-1.122-6.853h1.056c1.045 0 1.617.3 1.617 1.177S.979-4.367-.066-4.367h-1.056zM3.5 0 1.6-3.333a2.33 2.33 0 0 0 1.546-2.343c0-1.87-1.353-2.464-3.058-2.464H-2.75V0h1.628v-3.08H.011L1.683 0z" style="fill:#fff" transform="translate(8 12)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-request',
});
</script>
